<template>
  <div
    v-if="isLoading"
    class="gradient-bg fixed inset-0 h-screen p-8 gap-16 flex items-center justify-center z-[999]"
  >
    <BaseLogo class="pulse" />
  </div>
</template>

<script>
import * as motion from 'motion'
import { mapState } from 'vuex'

import BaseLogo from '@/components/Base/BaseLogo.vue'

export default {
  name: 'AppLoader',

  components: { BaseLogo },

  data: () => ({
    isLoading: false
  }),

  computed: {
    ...mapState('auth', ['isInitialLoading'])
  },

  watch: {
    isInitialLoading: {
      immediate: true,
      handler(isInitialLoading) {
        if (isInitialLoading) {
          this.isLoading = true
        } else {
          this.handleHideLoading()
        }
      }
    }
  },

  methods: {
    async handleHideLoading() {
      const el = this.$el

      if (!el) {
        this.isLoading = false
        return
      }

      motion
        .animate(el, { opacity: 0 }, { duration: 0.5 })
        .finished.then(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.85);
  }

  70% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.85);
  }
}

.pulse {
  transform: scale(1);
  animation: pulse 2s infinite;
}

.gradient-bg {
  background: linear-gradient(167.65deg, white 40%, #fff1dd 100%);
  background-size: 200% 200%;
  animation: gradient 5s ease infinite;
}
</style>
